import { render, staticRenderFns } from "./Position_set.vue?vue&type=template&id=8789dc0a&"
import script from "./Position_set.vue?vue&type=script&lang=js&"
export * from "./Position_set.vue?vue&type=script&lang=js&"
import style0 from "./Position_set.vue?vue&type=style&index=0&id=8789dc0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports